<div class="main_container">
  <div class="module-header">
    <div class="pageName">
      <app-custom-datepicker [dateControl]="date" [dateClass]="dateClass" (dateChange)="changeDate($event.value)">
      </app-custom-datepicker>
      <div *ngIf="areas$ | async as areas">
        <div class="flex-wrap" style="align-items: center; height: 29px;">
          <h3 class="pageName__subtitle">{{nombreArea(areas)}}</h3>
          <div>
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon class="area-icon-button"><span class="icon">more_vert</span></mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button *ngFor="let area of areas" mat-menu-item (click)="navegarArea(area)">
                {{area.nombre}}
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [formGroup]="filtroCursos">
    <div class="table-tools">
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por curso</mat-label>
        <mat-select formControlName="curso" placeholder="Filtrar curso">
          <mat-option value="{{0}}">Todos</mat-option>
          <ng-container *ngFor="let curso of cursos$ | async">
            <ng-container *ngFor="let cursoDetalle of curso.cursos">
              <mat-option [value]="cursoDetalle.id">{{cursoDetalle.nombre}}</mat-option>
            </ng-container>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por responsable</mat-label>
        <input matInput formControlName="nombre">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por materia</mat-label>
        <input matInput formControlName="materia">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Filtrar por estado</mat-label>
        <mat-select formControlName="estado" placeholder="Filtrar curso">
          <mat-option value="{{0}}">Todos</mat-option>
          <mat-option value="{{1}}">Asistencia tomada</mat-option>
          <mat-option value="{{2}}">Asistencia no registrada</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="notificar()" class="row-last-item" >Notificar</button>
    </div>
  </div>
  <div *ngIf="dataSource !== null" class="module-content">
    <div class="full-width mat-elevation-z2" *ngIf="dataSource.length">
      <table mat-table [dataSource]="dataSource" class="full-width">
        <ng-container matColumnDef="check">
          <th mat-header-cell *matHeaderCellDef style="flex: 1;">
            <form [formGroup]="checkForm">
              <mat-checkbox (change)="selectAll($event.checked, dataSource)"></mat-checkbox>
            </form>
          </th>
          <td mat-cell *matCellDef="let element" style="flex: 1;">
            <form [formGroup]="checkForm">
              <mat-checkbox [formControlName]="element.materiaCursoPeriodoID" color="primary"
                [disableRipple]="true" (click)="$event.stopPropagation();"></mat-checkbox>
            </form>
          </td>
        </ng-container>
        <ng-container matColumnDef="curso">
          <th mat-header-cell *matHeaderCellDef style="flex: 1;"> Curso </th>
          <td mat-cell *matCellDef="let element" style="flex: 1;">
            <div class="full-width">
              {{element.curso.nickName}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Estado </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              {{asistencias(element.horasClase)}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="ausencias">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Ausencias </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              <label>{{element.ausencias}}</label>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="retardos">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Retardos </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              <label>{{element.retardos}}</label>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="responsable">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Responsable </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              <ul style="margin:0; padding:0;">
                <li *ngFor="let prof of element.profesores as profesores; index as i" style="margin-bottom: 4px;">
                  <strong>
                    {{i !== element.profesores.length - 1 ? prof.nombresApellidos + '' : prof.nombresApellidos}}
                  </strong><br>
                  <label class="opacity-medium">
                    {{i !== element.profesores.length - 1 ? prof.eMail + '' : prof.eMail}}</label>
                </li>
              </ul>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Email </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              <label *ngFor="let prof of element.profesores as profesores; index as i">
                {{i !== element.profesores.length - 1 ? prof.eMail + ',' : prof.eMail}}</label>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef style="flex: 2;"> Materia </th>
          <td mat-cell *matCellDef="let element" style="flex: 2;">
            <div class="full-width">
              <a (click)="navigate(element.materiaCursoPeriodoID)">{{element.nombre}}</a>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="['check','curso','responsable','link','ausencias', 'retardos','estado']">
        </tr>
        <tr mat-row
          *matRowDef="let row; columns: ['check','curso','responsable','link','ausencias', 'retardos','estado'];">
        </tr>
      </table>
    </div>
  </div>
  <div *ngIf="dataSource === null; else lengthCero">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  <ng-template #lengthCero>
    <p  *ngIf="dataSource.length === 0" class="no-records">Sin registros</p>
  </ng-template>
</div>
